export const CREATE_CATALOG_FINANCIAL = "CREATE_CATALOG_FINANCIAL";
export const LOAD_CATALOG_FINANCIAL_SUCCESS = "LOAD_CATALOG_FINANCIAL_SUCCESS";
export const CREATE_CATALOG_FINANCIAL_SUCCESS = "CREATE_CATALOG_FINANCIAL_SUCCESS";
export const UPDATE_CATALOG_FINANCIAL_SUCCESS = "UPDATE_CATALOG_FINANCIAL_SUCCESS";
export const DELETE_CATALOG_FINANCIAL_OPTIMISTIC = "DELETE_CATALOG_FINANCIAL_OPTIMISTIC";